import { render } from "./AddCollectionModal.vue?vue&type=template&id=f8af0fac&ts=true"
import script from "./AddCollectionModal.vue?vue&type=script&lang=ts"
export * from "./AddCollectionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__